import { render, staticRenderFns } from "./MypageHeader.vue?vue&type=template&id=7a850cec"
import script from "./MypageHeader.ts?vue&type=script&lang=ts&external"
export * from "./MypageHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports